// extracted by mini-css-extract-plugin
export var buttons = "S_bC";
export var container = "S_b";
export var image = "S_k";
export var p = "S_dK";
export var section = "S_j";
export var short = "S_dL";
export var textContainer = "S_b6";